import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { Link } from '@alfa-bank/site-link';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Img } from '@alfa-bank/site-img';
import { Grid } from '@alfa-bank/site-grid-universal';

import type { TTileDesktop, ITileDepsDesktop } from '../../../models';

import styles from './styles/tile.css';
import { TileComponentDesktop as Component } from './tile';

export const TileDesktop = createWidget<ITileDepsDesktop, TTileDesktop>({
    Block,
    Link,
    Text,
    Img,
    Grid,
    styles,
})(Component);
